import { MasterSolutionEnums } from "src/app/enum/master-solution-Enums";

export class MasterSolutionModel {
  masterSolutionId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterCode: string | null = null;
  name: string = "";
  description: string = "";
  masterSolutionState: number = MasterSolutionEnums.open;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}










